var useDateUtils = function () {
    var isValidDate = function (value) {
        if (value == null || value == '')
            return true;
        var date = new Date(value);
        return (Object.prototype.toString.call(date) === '[object Date]' &&
            !isNaN(date.getTime()));
    };
    return { isValidDate: isValidDate };
};
export default useDateUtils;
